import React from 'react';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';

import { toggleChat } from 'actions/chatAction';

import { HELP, LOGIN } from 'constants/UrlConstants';

import { apiFetchData } from 'helpers/api';

import { PromoInfoPage } from '../no-auth/common/PromoInfoPage/PromoInfoPage';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            errorInfo: null,
        };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo,
        });
        this.sendErrorsToServer(error, errorInfo);
    }

    sendErrorsToServer(error, errorInfo) {
        const message = {
            name: 'message',
            value: 'JS Error!  in "' + document.URL + '".',
        };
        const exception = {
            name: 'exception',
            value: error?.stack + '\n' + errorInfo?.componentStack,
        };
        apiFetchData('/exception', { message: message, exception: exception });
    }
    openChat = () => {
        this.props.toggleChat(true);
    };

    render() {
        if (this.state.errorInfo) {
            return (
                <PromoInfoPage
                    animatedIconFail
                    headerText={<Trans>ps.500.title</Trans>}
                    secondaryText={<Trans>ps.404.error.description</Trans>}
                    buttonRowType="link"
                    backUrl={LOGIN}
                    leftCloseIcon
                    isTagA
                    buttonRowCaption={<Trans>ps.404.help</Trans>}
                    buttonRowHref={HELP}
                    primaryButtonCaption={<Trans>ps.404.chat.button</Trans>}
                    primaryButtonOnClick={this.openChat}
                />
            );
        }
        return this.props.children;
    }
}

export default connect(null, { toggleChat })(ErrorBoundary);
